export enum TrainingCourseSectionState {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
};
